import React, { useState } from "react";
import "./App.css";
import { Route, Switch } from "react-router";
import LokalForening from "./lokalforening/Lokalforening";
import { Container } from "@material-ui/core";
import AdminPanel from "./adminpanel/AdminPanel";
import Login from "./login/Login";
import GaverBidrag from "./gaverbidrag/GaverBidrag";
import Home from "./Home";
import { BrowserRouter, NavLink } from "react-router-dom";
import Eiendom from "./eiendom/Eiendom";
import Modal from "./customhtmlcomponents/modal/Modal";
import { ResponseData } from "./adminpanel/panels/types/types";
import Styret from "./styret/Styret";
import Aktivitet from "./aktiviteter/Aktiviteter";
import Rapport from "./rapport/Rapport";
import Kos from "./kos/Kos";
import useToken from "../services/useToken";
import useUser from "../services/useUser";
import useCurentForeningReportNumber from "../services/useForening";
import Regnskapstabell from "./regnskapstabell/Regnskapstabell";

function App() {
  const { user, scopes, setUser } = useUser();
  const isScopesSet = scopes !== undefined && scopes !== null;
  const isViewer = isScopesSet
    ? scopes.includes("ROLE_VIEWER")
    : false;
  const isAdmin = isScopesSet
    ? scopes.includes("ROLE_ADMIN")
    : false;

  const { currentForeningReportNumber, setCurrentForeningReportNumber } =
    useCurentForeningReportNumber();
  const { token, setToken } = useToken();
  const [modal, setModal] = useState<boolean>(false);
  const [message, setMessage] = useState<{ body: ResponseData }>({
    body: {
      body: {
        foreningsNavn: "",
        foreningsNummer: 0,
        password: "",
        active: true,
        message: "",
      },
    },
  });
  return (
    <BrowserRouter>
      <div className="bg-sk-tertiary-red">
        <Container className="pt-8 border-b-2 border-gray-300 mb-8">
          <img
            className="m-auto mb-8 w-3/5"
            src="https://sanitetskvinnene.no/themes/nks2019/assets/images/logo.svg"
            alt="Sanitetskvinnenes logo"
          />
        </Container>
        {!token ? (
          <Login
            setUser={setUser}
            setToken={setToken}
            setCurrentForeningReportNumber={setCurrentForeningReportNumber}
          />
        ) : (
          <div className="content-center">
            <div className="absolute right-0 top-0">
              <p className="pr-4">{`Velkommen, ${user}`}</p>

              {(isAdmin || isViewer) && (
                <NavLink
                  className=" pl-4 hover:text-sk-navbar-text-active text-blue-500"
                  to="/adminpanel"
                  activeClassName="underline hover:text-blue-800"
                  onClick={() => window.confirm("Har du husket å lagre data?")}
                >
                  Admin panel
                </NavLink>
              )}
              <button
                className="bg-white uppercase tracking-wider group flex  py-2.5 mx-auto px-6 border border border-4 border-sk-primary-blue text-sm font-medium rounded-3xl text-black hover:bg-sk-primary-blue-200 hover:opacity-70 focus:outline-none focus:ring-2 focus:ring-offset-2"
                onClick={() => setToken("")}
              >
                LOGG UT
              </button>
            </div>
            {modal && <Modal body={message.body.body} />}
            <Switch>
              <Route
                path="/login"
                render={(props) => (
                  <Login
                    {...props}
                    setToken={setToken}
                    setUser={setUser}
                    setCurrentForeningReportNumber={
                      setCurrentForeningReportNumber
                    }
                  />
                )}
              />
              <Route
                path="/adminpanel"
                render={(props) => (
                  <AdminPanel
                    {...props}
                    isAdmin={isAdmin}
                    isViewer={isViewer} 
                    token={token}
                    username={user}
                    message={setMessage}
                    setModal={setModal}
                    setCurrentForeningReportNumber={
                      setCurrentForeningReportNumber
                    }
                  />
                )}
              />
              <Route path="/" render={() => <Home />} exact />
              <Route
                path="/lokalforening"
                render={(props) => (
                  <>
                    <LokalForening
                      {...props}
                      currentForeningReportNumber={currentForeningReportNumber}
                      username={user as string}
                      message={setMessage}
                      setModal={setModal}
                    />
                  </>
                )}
              />
              <Route
                path="/styret"
                render={() => (
                  <>
                    <Styret
                      setCurrentForeningReportNumber={
                        setCurrentForeningReportNumber
                      }
                      currentForeningReportNumber={currentForeningReportNumber}
                      username={user as string}
                      message={setMessage}
                      setModal={setModal}
                    />
                  </>
                )}
              />
              <Route
                path="/eiendom"
                render={() => (
                  <>
                    <Eiendom
                      setModal={setModal}
                      message={setMessage}
                      currentForeningReportNumber={currentForeningReportNumber}
                      username={user as string}
                    />
                  </>
                )}
              />
              <Route
                path="/aktiviteter"
                render={() => (
                  <>
                    <Aktivitet
                      currentForeningReportNumber={currentForeningReportNumber}
                      username={user as string}
                      message={setMessage}
                      setModal={setModal}
                    />
                  </>
                )}
              />
              <Route
                path="/kos"
                render={() => (
                  <>
                    <Kos
                      setCurrentForeningReportNumber={
                        setCurrentForeningReportNumber
                      }
                      currentForeningReportNumber={currentForeningReportNumber}
                      username={user as string}
                      message={setMessage}
                      setModal={setModal}
                    />
                  </>
                )}
              />
              <Route
                path="/gbm"
                render={() => (
                  <>
                    <GaverBidrag
                      setModal={setModal}
                      message={setMessage}
                      username={user as string}
                      currentForeningReportNumber={currentForeningReportNumber}
                    />
                  </>
                )}
              />
              <Route
                path="/regnskapstabell"
                render={() => (
                  <>
                    <Regnskapstabell
                      setModal={setModal}
                      message={setMessage}
                      username={user as string}
                      currentForeningReportNumber={currentForeningReportNumber}
                    />
                  </>
                )}
              />
              <Route
                path="/avslutt"
                render={() => (
                  <>
                    <Rapport
                      message={setMessage}
                      setModal={setModal}
                      currentForeningReportNumber={currentForeningReportNumber}
                      username={user as string}
                    />
                  </>
                )}
              />
            </Switch>
          </div>
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
